import React, { MouseEvent } from 'react'

import { Box, Flex, Icon, Text } from '@driftt/dds'
import { faArrowLeft } from '@driftt/dds.icons/light/faArrowLeft'
import { A } from '@driftt/tide-core'

import { useAppSelector } from 'hooks/useRedux'
import { ActivityForContact } from 'modules/accountActivity/domain'
import { userActivityTypeToPreviewSnippet } from 'utils/activity'
import { timeSinceUpdated } from 'utils/timeStamp'

import FormattedActivity from '../FormattedActivity'

import styles from './styles.module.css'

interface ActivityListProps {
  activityList: ActivityForContact[]
  maxActivitiesToShow: number
  onClickShowMoreActivities: () => void
}

const isValidUrl = (urlString: string) => {
  try {
    new URL(urlString)
    return true
  } catch (e) {
    return false
  }
}

const ActivityList: React.FC<ActivityListProps> = ({
  activityList,
  maxActivitiesToShow,
  onClickShowMoreActivities
}) => {
  const orgUsersById = useAppSelector(({ orgUsersById }) => orgUsersById.users)
  return (
    <>
      {activityList.slice(0, maxActivitiesToShow).map((activity: ActivityForContact, i: number) => (
        <div key={i} className={styles.activityInfo}>
          {activity.activityContext.referrer && isValidUrl(activity.activityContext.referrer) && (
            <Box css={{ paddingBottom: '$1' }}>
              <div className={styles.iconAndTime}>
                <Icon size="extra-small" css={{ marginTop: "2px" }} icon={faArrowLeft} />
                <div className={styles.activityTime}>{`${timeSinceUpdated(
                  activity.createdAt
                )} ago`}</div>
              </div>
              <Flex
                gap="half"
                css={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
                alignItems="center"
                fullWidth>
                <Text variant="body" css={{ color: "$gray8" }}>referred from</Text>
                <Text variant="body">{new URL(activity.activityContext.referrer).hostname}</Text>
              </Flex>
            </Box>
          )}
          <div className={styles.iconAndTime}>
            <Icon size="extra-small" css={{ marginTop: "2px" }} icon={userActivityTypeToPreviewSnippet(activity, orgUsersById).icon} />
            <div className={styles.activityTime}>{`${timeSinceUpdated(
              activity.createdAt
            )} ago`}</div>
          </div>
          <FormattedActivity activity={activity} />
        </div>
      ))}
      {activityList.length > maxActivitiesToShow && (
        <A
          className={styles.loadMore}
          onClick={(e: MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation()
            onClickShowMoreActivities()
          }}>
          Load more activities
        </A>
      )}
    </>
  )
}

export default ActivityList
